import classNames from 'classnames';
import { useI18n } from '@/libraries/contexts/i18n-context';
import { useState } from 'react';
import AnchorLink from '@/components/molecules/anchor-link/anchor-link';
import Calendar from '@/components/organisms/calendar/calendar';
import { useWindowSize } from '@/libraries/hooks/use-window-size';
import styles from './low-price-calendar.module.scss';

export interface LowPriceCalendarProps {
  /** The class name to apply */
  className?: string;
  /** A list of available dates that are highlighted in the calendar */
  highlightedDates?: Date[];
  /** Indicates whether the dropdown is in a loading state */
  isLoading?: boolean;
  /** Locale for the calendar labels */
  locale?: Locale;
  /** A list of low price dates to highlight in the calendar */
  lowPriceDates?: Date[];
  /** A list of offers to show in the calendar */
  offers?: Date[];
  /** An event that is triggered on change */
  onChange?: (selectedDates: Date[]) => void;
  /** Preselected date in the calendar */
  selectedDate?: Date | null;
}

const LowPriceCalendar = ({
  className,
  onChange,
  ...rest
}: LowPriceCalendarProps) => {
  const { t } = useI18n();
  const [isVisible, setIsVisible] = useState(false);
  const isLaptop = useWindowSize('laptop');

  const handleClick = () => {
    setIsVisible(previous => !previous);
  };

  return (
    <div className={classNames(styles.component, className)}>
      {isVisible && (
        <Calendar
          {...rest}
          customRangeStyle
          displayedMonths={isLaptop ? 2 : 1}
          onChange={onChange}
        />
      )}

      <AnchorLink
        onClick={handleClick}
        text={
          isVisible
            ? t('items.search.lowPriceCalendar.hidePriceCalendar')
            : t('items.search.lowPriceCalendar.showPriceCalendar')
        }
      />
    </div>
  );
};

LowPriceCalendar.displayName = 'LowPriceCalendar';

export default LowPriceCalendar;
